import "./statusPill.css";

const StatusPill = (props: any) => {
  switch (props.status) {
    case "Released":
      return <div className="readyToGo-pill label-pill">Released</div>;
    case "Inwork":
    case "Undefined":
    case "New":
      return <div className="comingSoon-pill label-pill">New</div>;
    case "Obsolete":
      return <div className="obsolete-pill label-pill">Obsolete</div>;
    default:
      return <div className="unknown-pill label-pill">Unknown</div>;
  }
};

export default StatusPill;
